(function () {
  'use strict';

  if (window.__plzFaqBooted) return;
  window.__plzFaqBooted = true;

  function ensureAnswerWrap(answer) {
    if (!answer || answer.classList.contains('plz-faq-main__a') === false) return null;

    var parent = answer.parentElement;
    if (parent && parent.classList.contains('plz-faq-main__answer-inner')) {
      return parent.parentElement;
    }

    var wrap = document.createElement('div');
    wrap.className = 'plz-faq-main__answer-wrap';
    var inner = document.createElement('div');
    inner.className = 'plz-faq-main__answer-inner';
    answer.parentNode.insertBefore(wrap, answer);
    inner.appendChild(answer);
    wrap.appendChild(inner);
    return wrap;
  }

  function prepareItem(item) {
    if (!item || item.dataset.plzFaqReady === 'true') return;
    var answer = item.querySelector('.plz-faq-main__a');
    if (!answer) return;
    ensureAnswerWrap(answer);
    item.dataset.plzFaqReady = 'true';
  }

  function prepareRoot(root) {
    if (!root) return;
    root.querySelectorAll('.plz-faq-main__item').forEach(prepareItem);
  }

  function prepareAll() {
    document.querySelectorAll('.plz-faq').forEach(prepareRoot);
  }

  function setItemOpen(item, open) {
    if (!item) return;
    var btn = item.querySelector('[data-faq-toggle]');
    item.classList.toggle('is-open', open);
    if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function handleToggle(btn) {
    var item = btn.closest('.plz-faq-main__item');
    if (!item) return;
    prepareItem(item);
    setItemOpen(item, !item.classList.contains('is-open'));
  }

  function initTabs(root) {
    if (!root || root.dataset.plzFaqTabsReady === 'true') return;
    if (!root.hasAttribute('data-plz-faq')) return;

    root.querySelectorAll('[data-faq-tab]').forEach(function (tab) {
      tab.addEventListener('click', function () {
        var key = tab.getAttribute('data-faq-tab');
        root.querySelectorAll('[data-faq-tab]').forEach(function (t) {
          var active = t.getAttribute('data-faq-tab') === key;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        root.querySelectorAll('[data-faq-panel]').forEach(function (panel) {
          panel.classList.toggle('is-active', panel.getAttribute('data-faq-panel') === key);
        });
        if (window.matchMedia('(max-width: 900px)').matches) {
          var tabs = tab.closest('.plz-faq-main__tabs');
          if (tabs) {
            var target = tab.offsetLeft - (tabs.clientWidth - tab.offsetWidth) / 2;
            tabs.scrollTo({ left: Math.max(0, target), behavior: 'smooth' });
          }
        }
      });
    });

    root.dataset.plzFaqTabsReady = 'true';
  }

  function initFaqRoots() {
    document.querySelectorAll('[data-plz-faq]').forEach(initTabs);
    prepareAll();
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-faq-toggle]');
    if (!btn) return;
    event.preventDefault();
    handleToggle(btn);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFaqRoots);
  } else {
    initFaqRoots();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target;
    if (!section) return;
    section.querySelectorAll('[data-plz-faq]').forEach(initTabs);
    section.querySelectorAll('.plz-faq').forEach(prepareRoot);
    section.querySelectorAll('[data-plz-faq-embed]').forEach(prepareRoot);
  });
})();
